module.exports = __webpack_public_path__ + "img/img6.3a008c77.png";